import { DatePipe, registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { File } from '@ionic-native/file';
import { NativeAudio } from '@ionic-native/native-audio';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { InstructionsPage } from '../pages/instructions/instructions';
import { MPTPage } from '../pages/mpt/mpt';
import { TapCanvas } from '../pages/mpt/tap-canvas';
import { RecordsPage } from '../pages/records/records/records';
import { RecordsProbandPage } from '../pages/records/recordsSession/recordsProband';
import { SessionPage } from '../pages/session/session';
import { SettingsPage } from '../pages/settings/settings';
import { AudioProvider } from '../provider/audio-service';
import { DataProvider } from '../provider/data-service';
import { HelperProvider } from '../provider/helper-service';
import { SettingsProvider } from '../provider/settings-service';
import { MyApp } from './app.component';

registerLocaleData(localeDE, 'de');

@NgModule({
  declarations: [
    MyApp,
    SessionPage,
    InstructionsPage,
    MPTPage,
    SettingsPage,
    RecordsPage,
    RecordsProbandPage,
    TapCanvas
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    ReactiveFormsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    SessionPage,
    InstructionsPage,
    MPTPage,
    SettingsPage,
    RecordsPage,
    RecordsProbandPage
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    StatusBar,
    SplashScreen,
    NativeAudio,
    File,
    DatePipe, // ist nur hier da es auch als injectable in ts code verwendet wird (zum Formatieren von Date)
    SettingsProvider,
    DataProvider,
    HelperProvider,
    AudioProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts